// author：jiana
// time:2024-06-12
// desc:本页面为方便快速构建vue文件模板基础页面搭建，在次基础上快速搭建

<template>
	<div class="yunyangniu">
		<!-- 顶部导航 -->
		<menuNav :bgClass="bgClass"></menuNav>
		<!-- 第一屏 -->
		<div class="screenSize">
			<el-carousel height="100vh" arrow='never'>
				<el-carousel-item>
					<img src="../../assets/imgs/banner1.png" alt="" />
				</el-carousel-item>
				<el-carousel-item>
					<img src="../../assets/imgs/banner2.png" alt="" />
				</el-carousel-item>
				<el-carousel-item>
					<img src="../../assets/imgs/banner3.png" alt="" />
				</el-carousel-item>
			</el-carousel>
		</div>
		<!-- 第二屏 -->
		<div class="box1200">
			<div class="titleImg">
				<img src="../../assets/imgs/yunTitle1.png" alt="">
			</div>
			<div class="infoBox">
				通过AI、Big Data、Iot等数据技术产品，自动获取奶牛行为底层数据， <br>
				提供牧场经营管理全维度分析。通过海量数据训练智能AI管理模型，通过该模型做出数据分析预测，及时反馈运营优化经营，<br>
				让牧场没有难养的牛。
			</div>
			<div class="margin30">
				<el-row>
					<el-col :span="8">
						<div class="caiji">
							<img src="../../assets/imgs/data1.png" alt="" class="dataBox">
							<div class="biaoti">采集</div>
							<div class="biaotiOne">物联  传感</div>
							<div class="biaotiTwo">智能项圈、精准饲喂、 <br>犊牛饲喂系统、智能称重等</div>
							<div class="biaotiThree">AIOT设备</div>
							<div class="biaotiTwo">检测动物运动、反刍、采食 <br>体温、位置、休息等数据</div>
						</div>
					</el-col>
					<el-col :span="8">
						<div class="fenxi">
							<img src="../../assets/imgs/data2.png" alt="" class="dataBox">
							<div class="biaoti">分析</div>
							<div class="biaotiOne">集成分析系统</div>
							<div class="biaotiTwo">养殖运营分析 <br>异常管理分析</div>
							<div class="biaotiThree">计算分析</div>
							<div class="biaotiTwo">自动上传数据、分析数据判断<br>动物行为饮食、健康、发情、挤奶、<br>位置等状态</div>
						</div>
					</el-col>
					<el-col :span="8">
						<div class="juece">
							<img src="../../assets/imgs/data3.png" alt="" class="dataBox">
							<div class="biaoti">决策</div>
							<div class="biaotiOne">智能决策系统</div>
							<div class="biaotiTwo">自动工单<br>智慧决策</div>
							<div class="biaotiThree">指导决策</div>
							<div class="biaotiTwo">指导养殖过程、员工自主派发工单<br>综合牛只事件信息、给出建议淘牛明细</div>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
		<!-- 第三屏 -->
		<div class="box1200">
			<div class="farmBox">
				<img src="../../assets/imgs/farm.png" alt="">
			</div>
			<div class="titleImg">
				<img src="../../assets/imgs/yunTilte2.png" alt="">
				<div class="secondTitle">软硬兼施 关联各环生产数据 助力牧场降本增效</div>
			</div>
			<div class="marginBottom30">
				<div class="fananBox" @click="$jump('/breedHealth')">
					<div class="fangan1">智能脖环</div>
					<div class="beijing1">
						<div class="textOne">全天候24小时监测<br>体征早发现早止损早治疗</div>
						<div class="textTwo">通过对奶牛体温、进食、反刍、<br>休息等关键指标的监测,及时<br>发现健康事件,精准揭发发情事件</div>
					</div>
				</div>
				<div class="fananBox" @click="$jump('/feed')">
					<div class="fangan1">精准饲喂</div>
					<div class="beijing1">
						<div class="textOne">从饲喂管理到营养分析制作<br>更精准 营养更科学</div>
						<div class="textTwo">配方科学的前提下,还需要日粮<br>制作精准,日粮投喂精准,减少饲料<br>的浪费,保障配方与日粮的一致性</div>
					</div>
				</div>
				<div class="fananBox" @click="$jump('/feed')">
					<div class="fangan1">犊牛饲喂</div>
					<div class="beijing1">
						<div class="textOne">全天候24小时监测<br>体征早发现早止损早治疗</div>
						<div class="textTwo">实现每头牛自动定量饲喂,高效便捷</div>
					</div>
				</div>
				<div class="fananBox" @click="$jump('/feed')">
					<div class="fangan1">自动称重</div>
					<div class="beijing1">
						<div class="textOne">体重数据实测上云高效 准确</div>
						<div class="textTwo">自动上传至云养牛管理平台,将<br>体重数据与生产系统关联,模拟<br>生产生长曲线、异常体重分析</div>
					</div>
				</div>
				<div class="fananBox" @click="$jump('/cowshed')">
					<div class="fangan1">智慧牛舍</div>
					<div class="beijing1">
						<div class="textOne">舒适的奶牛生产环境<br>远程管控 节省人力</div>
						<div class="textTwo">通过物联网连接传统设备,数据<br>上传,喷淋、水槽、环控、电力,<br>实现远程管控,云端分析</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 第四屏 -->
		<div class="screenSizeOne">
			<img src="../../assets/imgs/tu1.png" alt="" class="tuBox" @click="$jump('/smartRanch')"/>
			<img src="../../assets/imgs/tu2.png" alt="" class="tuBox" @click="$jump('/breedHealth')"/>
		</div>
		<!-- 第五屏 -->
		<div class="screenSizeOne">
			<img src="../../assets/imgs/tu3.png" alt="" class="tuBox" @click="$jump('/feed')"/>
			<img src="../../assets/imgs/tu4.png" alt="" class="tuBox" @click="$jump('/feed')"/>
		</div>
		<!-- 第六屏 -->
		<div class="screenSizeOne">
			<img src="../../assets/imgs/tu5.png" alt="" class="tuBox" @click="$jump('/cowshed')"/>
			<img src="../../assets/imgs/tu6.png" alt="" class="tuBox" @click="$jump('/dairyParlor')"/>
		</div>
		<!-- 第七屏 -->
		<div class="">
			<img src="../../assets/imgs/footImg.png" alt="" class="footBox"/>
		</div>
		<!-- 底部 -->
		<footerIndex></footerIndex>
	</div>
</template>

<script>
import footerIndex from '../../components/footer/footerIndex.vue'
import menuNav  from '../../components/nav/menuNav.vue'
export default {
	name: 'yunyangniu',
	components: {
		footerIndex,menuNav
	},
	props:{
		
	},
	data() {
		return {
			bgClass:true,
		}
	},
	computed: {

	},
	methods: {
	},

	mounted() {
	},

	watch: {

	}
}
</script>

<style lang="less" scoped>
body {
    margin: 0; /* 如果页面出现垂直滚动条，则加入此行CSS以消除之 */
}
.box1200{
	width: 1200PX;
	margin: 0 auto;
}
.yunyangniu{
	color: #333333;
	.screenSize{
		width: 100%;
		height: 100vh;
		img{
			width: 100%;
			height: 100%;
		}
	}
	.marginTop50{
		margin-top: 50px;
	}
	.screenSizeOne{
		width: 100%;
		height: 100vh;
	}
	.tuBox{
		width: 100%;
		height: 50vh;
		float: left;
  		display: block;
	}
	.farmBox{
		width: 100%;
		height: 50vh;
		margin-top: 50px;
		img{
			width: 100%;
			height: 100%;
		}
	}
	.titleImg{
		width: 220px;
		margin: 50px auto 30px;
		// height: 100px;
		img{
			width: 100%;
			height: 100%;
		}
	}
	.infoBox{
		text-align: center;
		color: #333;
		font-size: 10px;
		line-height: 20px;
	}
	.margin30{
		margin: 30px 0;
	}
	.caiji{
		width: 200px;
		height: 350px;
		border-radius: 27px;
		backdrop-filter: blur(5.44px);
		background: linear-gradient(159.98deg, rgba(255, 251, 249, 0.37) -0.692%,rgba(255, 245, 232, 0.75) 115.84%);
		text-align: center;
		color: #333333;
		margin: auto;
	}
	.fenxi{
		width: 200px;
		height: 350px;
		border-radius: 27px;
		border-radius: 27px;
		backdrop-filter: blur(5.44px);
		background: linear-gradient(159.98deg, rgba(249, 255, 253, 0.37) -0.692%,rgba(232, 255, 247, 0.75) 115.84%);
		text-align: center;
		color: #333333;
		margin: auto;
	}
	.juece{
		width: 200px;
		height: 350px;
		border-radius: 27px;
		border-radius: 27px;
		backdrop-filter: blur(5.44px);
		background: linear-gradient(159.98deg, rgba(249, 251, 255, 0.37) -0.692%,rgba(232, 247, 255, 0.75) 115.84%);
		text-align: center;
		color: #333333;
	    margin: auto;
	}
	.dataBox{
		margin: 30px 0 20px;
	}
	.biaoti{
		font-size: 18px;
	}
	.biaotiOne{
		font-size: 14px;
		margin: 10px 0;
	}
	.biaotiTwo{
		font-size: 11px;
	}
	.biaotiThree{
		font-size: 14px;
		margin: 20px 0 10px;
	}
	.secondTitle{
		font-size: 10px;
		text-align: center;
		margin-top: 10px;
	}
	.fangan1{
		background: url('../../assets/imgs/juxing.png');
		background-size: 100% 100%;
		width: 90%;
		height: 38px;
		text-align: center;
		color: #fff;
		line-height: 38px;
		font-size: 16px;
		margin: auto;
	}
	.fananBox{
		width: 160px;
		height: 200px;
		cursor: pointer;
	}
	.beijing1{
		background: url('../../assets/imgs/beijing.png');
		background-size: 100% 100%;
		width: 100%;
		height: 150px;
		text-align: center;
		padding-top:20px;
	}
	.marginBottom30{
		margin-bottom: 30px;
		display: flex; 
		flex-direction:row;
		justify-content:space-between;
	}
	.textOne{
		margin-bottom: 20px;
		font-size: 10px;
		line-height: 16px;
	}
	.textTwo{
		line-height: 16px;
	}
	.footBox{
		width: 100%;
		height: 70vh;
	}
}
</style>
